import React from 'react';
import { ShieldCheckIcon, ClockIcon, HomeIcon, HeartIcon } from 'lucide-react';
const AboutUs = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-150">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-151">
        <div className="container mx-auto px-4 text-center" data-id="element-152">
          <h1 className="text-4xl font-bold mb-6" data-id="element-153">About Us</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-154">
            Learn more about Opticore and our commitment to excellence in
            appliance repair and maintenance.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-155">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-156">
          <div data-id="element-157">
            <h2 className="text-3xl font-bold text-[#1a3a6c] mb-6" data-id="element-158">
              Your Trusted Appliance Repair Partner
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-159">
              At Opticore, we specialise in fast, professional appliance repairs
              and service plans across the UK. From kitchens to living rooms,
              our trusted engineers are here to help with all your appliance
              needs.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-160">
              We understand how disruptive faulty appliances can be to your
              daily routine. That's why we offer prompt, reliable service with
              fixed-price support and transparent pricing, giving you complete
              peace of mind.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-161">
              Our team of highly trained engineers has extensive experience
              diagnosing and repairing a wide range of household appliances. We
              take pride in our work and are committed to delivering exceptional
              service on every job.
            </p>
            <p className="text-gray-700" data-id="element-162">
              With Opticore, you can trust that your appliances are in expert
              hands. We're dedicated to providing efficient, long-lasting
              repairs that restore your appliances to optimal performance.
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-163">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uSadyDpveyHDk4xnMgVNst/02._Cooker.png" alt="Technicians repairing kitchen appliances" className="w-full h-auto" data-id="element-164" />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-165">
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-166">
            <div className="bg-[#f0f9ff] p-3 rounded-full inline-flex mb-4" data-id="element-167">
              <ShieldCheckIcon size={32} className="text-[#3b82f6]" data-id="element-168" />
            </div>
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-2" data-id="element-169">
              Reliable Service
            </h3>
            <p className="text-gray-600" data-id="element-170">
              Our engineers are fully qualified and experienced in repairing all
              major appliance brands and models.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-171">
            <div className="bg-[#fff7ed] p-3 rounded-full inline-flex mb-4" data-id="element-172">
              <ClockIcon size={32} className="text-[#f97316]" data-id="element-173" />
            </div>
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-2" data-id="element-174">
              Fast Response
            </h3>
            <p className="text-gray-600" data-id="element-175">
              We aim to schedule engineer visits within 24-48 hours of your call
              to minimise disruption.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-176">
            <div className="bg-[#f0fdf4] p-3 rounded-full inline-flex mb-4" data-id="element-177">
              <HomeIcon size={32} className="text-green-500" data-id="element-178" />
            </div>
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-2" data-id="element-179">
              UK-Wide Coverage
            </h3>
            <p className="text-gray-600" data-id="element-180">
              We provide service across mainland UK, ensuring help is available
              wherever you're located.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-181">
            <div className="bg-[#fef2f2] p-3 rounded-full inline-flex mb-4" data-id="element-182">
              <HeartIcon size={32} className="text-red-500" data-id="element-183" />
            </div>
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-2" data-id="element-184">
              Customer Focused
            </h3>
            <p className="text-gray-600" data-id="element-185">
              We prioritise your satisfaction, with clear communication and
              transparent pricing.
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-8 mb-16" data-id="element-186">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6 text-center" data-id="element-187">
            Our Commitment to You
          </h2>
          <div className="space-y-4 text-gray-700" data-id="element-188">
            <p data-id="element-189">
              At Opticore, we believe in building lasting relationships with our
              customers through honest, reliable service. Our commitment goes
              beyond just fixing appliances—we aim to provide peace of mind and
              exceptional customer care at every step.
            </p>
            <p data-id="element-190">
              We understand that inviting someone into your home requires trust.
              That's why all our engineers are thoroughly vetted, professionally
              trained, and committed to treating your home with respect. They'll
              arrive at the scheduled time, wearing proper identification, and
              will always clean up after completing repairs.
            </p>
            <p data-id="element-191">
              We're proud to offer transparent pricing with no hidden costs. Our
              service plans provide comprehensive coverage at competitive rates,
              ensuring you receive excellent value for your investment in
              appliance protection.
            </p>
            <p data-id="element-192">
              Customer feedback is invaluable to us. We continuously strive to
              improve our services based on your experiences and suggestions.
              Your satisfaction is our ultimate measure of success.
            </p>
          </div>
        </div>
        <div className="bg-[#1a3a6c] text-white rounded-lg shadow-md p-8 text-center" data-id="element-193">
          <h2 className="text-2xl font-bold mb-6" data-id="element-194">
            Ready to Experience Our Service?
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto" data-id="element-195">
            Contact us today to learn more about our service plans or to
            schedule an appliance repair appointment.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-196">
            <a href="tel:08000554969" className="bg-[#f97316] hover:bg-[#ea580c] text-white font-bold py-3 px-6 rounded-md text-center transition-colors" data-id="element-197">
              Call 0800 055 4969
            </a>
            <a href="mailto:23tata0716@gmail.com" className="bg-transparent hover:bg-white/10 text-white font-bold py-3 px-6 rounded-md border-2 border-white text-center transition-colors" data-id="element-198">
              Email Us
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default AboutUs;